import { FormGroupInput, Card, Button } from "@/components/shared/index";
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(app) {
    app.component("fg-input", FormGroupInput);
    app.component("card", Card);
    app.component("p-button", Button);
  },
};

export default GlobalComponents;
